import React, { createContext, type Dispatch, type FunctionComponent, type ReactNode, useReducer } from 'react';
import _ from 'lodash';
import type { INewMemberContextState, NewMemberContextAction } from './newMemberContext.types';
import reducer from './newMemberContext.reducer';

const initialState: INewMemberContextState = {
  employment: undefined,
  information: undefined,
  positions: [{ key: _.uniqueId() }],
  jobTitles: undefined,
  acceptedTermsAndConditions: undefined,
  bypassPositions: false,
};

export const NewMemberContext = createContext<{
  state: INewMemberContextState;
  dispatch: Dispatch<NewMemberContextAction>;
}>({
  state: initialState,
  dispatch: () => null,
});

interface NewMemberProviderProps {
  children: ReactNode;
}

export const NewMemberProvider: FunctionComponent<NewMemberProviderProps> = ({ children }) => {
  const [state, dispatch] = useReducer(reducer, initialState);
  return <NewMemberContext.Provider value={{ state, dispatch }}>{children}</NewMemberContext.Provider>;
};
